import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { OnOffSwitch } from "@lifepay/rc-ui-toolkit";

import styles from "./OktellControls.m.scss";

function OktellControls(props) {
  const {
    theme,
    disable,
    isPingingForNewCalls,
    toggleOktellPing,
    canSync,
    isStateChanges,
  } = props;

  return (
    <div className={classnames(theme.wrapper)} hidden={disable}>
      <OnOffSwitch
        id={`oktell_sync`}
        name="oktell_sync"
        disabled={!canSync}
        wait={isStateChanges}
        checked={canSync && isPingingForNewCalls}
        onChange={toggleOktellPing}
        theme={{
          switch: theme.switch,
        }}
      >
        <div className={classnames(theme.label)}>
          {"Oktell"}
        </div>
      </OnOffSwitch>
    </div>
  );
}

OktellControls.displayName = "OktellControls";

OktellControls.propTypes = {
  disable: PropTypes.bool,
  theme: PropTypes.object,
  canSync: PropTypes.bool,
  isPingingForNewCalls: PropTypes.bool.isRequired,
  isStateChanges: PropTypes.bool.isRequired,
  toggleOktellPing: PropTypes.func.isRequired,
};

OktellControls.defaultProps = {};

export default themr("@lifepay/OktellControls", styles)(OktellControls);



// WEBPACK FOOTER //
// ./src/components/controls/OktellControls/OktellControls.js